module.exports = __webpack_public_path__ + "img/Innovazioni Griglia 2.1629a654.webp";